import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import {
  createModel,
  updateModelById,
  deleteModelById,
} from '../thunks/models';

const modelsAdapter = createEntityAdapter({});

export const modelsSlice = createSlice({
  name: 'models',
  initialState: modelsAdapter.getInitialState({}),
  reducers: {
    setModels: (state, action) => {
      modelsAdapter.upsertMany(state, action.payload);
    },
    addNewModel: (state, action) => {
      modelsAdapter.addOne(state, action.payload);
    },
    removeModel: (state, action) => {
      modelsAdapter.removeOne(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createModel.fulfilled, (state, action) => {
        modelsAdapter.upsertOne(state, action.payload);
      })
      .addCase(updateModelById.fulfilled, (state, action) => {
        const { id } = action.payload;
        modelsAdapter.updateOne(state, {
          id,
          changes: action.payload,
        });
      })
      .addCase(deleteModelById.fulfilled, (state, action) => {
        const { id } = action.payload;
        modelsAdapter.removeOne(state, id);
      });
  },
});

export const { setModels, addNewModel, removeModel } = modelsSlice.actions;

export const modelsAdapterSelectors = modelsAdapter.getSelectors(
  (state) => state.models
);

export default modelsSlice.reducer;
